import {
  CartItemProps,
  ProgressIndicator,
} from "@made-people/blueprint-cart-item";
import { PlusIcon } from "../../../assets/icons/Plus";
import { MinusIcon } from "../../../assets/icons/Minus";
import { LineItem } from "@made-people/grease-cart";
import { LineItemDeliveryStatus } from "../../features/delivery-status/line-item-delivery-status";

const CartItemCustomInfoComponent = (lineItem: LineItem) => (
  <LineItemDeliveryStatus lineItem={lineItem} />
);

export const CartItem: Omit<CartItemProps, "data"> = {
  templateProps: {
    template: "tokyo",
    removeItem: {
      // label: <Cross className="w-3 h-3" />,
      indicator: (
        <ProgressIndicator className="-left-[80px] absolute stroke-black place-self-center w-6" />
      ),
    },
    quantityPickerSettings: {
      addIcon: <PlusIcon className="w-3 h-3" />,
      addButtonSettings: {
        variants: {
          width: "same-as-height",
          rounded: "full",
          size: "sm",
          color: "grey",
        },
      },
      removeIcon: <MinusIcon className="w-3 h-auto" />,
      removeButtonSettings: {
        variants: {
          width: "same-as-height",
          rounded: "full",
          size: "sm",
          color: "grey",
        },
      },
    },
    customInfoComponent: CartItemCustomInfoComponent,
  },
};
